import { FormControl, TextFieldProps as MuiTextFieldProps } from '@mui/material'
import { memo } from 'react'
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'

import { ErrorMessage } from '@/components/organisms/error/ErrorMessage'
import { StyledTextField } from '@/components/uiParts/legacy/Input/TextField/style'
import { getErrorRecursive } from '@/utils/react_hook_form'

export type TextFieldProps = MuiTextFieldProps & {
  name: string
  rules?: RegisterOptions
  allowNull?: boolean
}

export const TextField = memo((props: TextFieldProps) => {
  const { name, rules, onChange, onBlur, inputProps, allowNull, ...rest } =
    props
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const error = rest.error || Boolean(getErrorRecursive(errors, name))

  return (
    <FormControl error={error} sx={{ width: '100%' }}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <StyledTextField
            {...rest}
            {...field}
            fullWidth
            error={error}
            value={field.value ?? ''}
            inputProps={{ ...inputProps, 'aria-label': name }}
            onChange={(event) => {
              if (allowNull && event.target.value === '') {
                // 空文字列の場合はnullに変換したeventオブジェクトを作成
                const modifiedEvent = {
                  ...event,
                  target: { ...event.target, value: null },
                }
                field.onChange(modifiedEvent)
              } else {
                field.onChange(event)
              }
              if (onChange) onChange(event)
            }}
            onBlur={(event) => {
              field.onBlur()
              if (onBlur) onBlur(event)
            }}
          />
        )}
      />
      <ErrorMessage errors={errors} name={name} />
    </FormControl>
  )
})

TextField.displayName = 'TextField'
